/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';

// Context
import AuthContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  IconButton,
  Box,
  TextField,
  Card,
  CardContent,
  Tab,
  Tabs,
  Menu,
  MenuItem,

} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPackageVariant,
  mdiSelectionMarker,
  mdiRuler,
  mdiTableColumnWidth,
  mdiTableRowHeight,
  mdiCounter,
  mdiMapMarkerCheckOutline,
  mdiPackageVariantClosed,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiTruckFastOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiCurrencyUsd,
  mdiHomeOutline,
  mdiBarcodeScan
} from '@mdi/js';

// Components
import ListOrderItems from './listPickMob/listPickMob';
import Can from '../../components/Can';
import PackageList from './packagesList';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import {
  translate,
  formaterPhoneNumber,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Status } from '../orders/interfaces';
import { Props } from './interfaces';
import { Link, useHistory } from 'react-router-dom';
import Modal from '../../components/Modal';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import orderItemsRepository from 'client-sdk/src/Repository/order-items.repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import ListDimensions from '../orderPack/dimensionsList';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import warehouseUnitRepository from 'client-sdk/src/Repository/warehouse-unit-repository';
import { DialogTitle } from '@material-ui/core';
import OrderItemDetail from '../orderPick/orderItemDetail';

// services
import { operatorAssigmentItemIssue } from '../../api/operator/post';
import RonadIcons from '../../components/iconComponent';


// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#5c5c5c',
      },
    },
    item: {
      marginBottom: '24px',

      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: '10px',
      flex: 0.5,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      marginTop: '24px',
      fontSize: '12px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    checkIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#039590',
      },
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    contentBox: {
      marginTop: '-1px',
      display: 'flex',
      flexDirection: 'column',
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },

    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paperHistory: {
      alignItems: 'center',
    },
    tileBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '100%',
      padding: '8px',
      justifyContent: 'center',
      borderRadius: '0',
      border: 'none'
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '52px',
      right: 0,
      borderBottom: 1,
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',

    },
    detail: {
      backgroundColor: 'white',
      padding: '5px',
      width: '100%',
    },
    btnBottom: {
      flexDirection: 'row',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#fff',
      bottom: '0',
      right: '0',
      padding: '15px 10px',
      zIndex: 2,
      borderTop: '1px solid lightgray',
    }
  })
);

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};

const TabPanel = (props: any) => {
  const { children, values, index, ...other } = props;

  return (

    <div
      role="tabpanel"
      hidden={values !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {values === index && <Box>{children}</Box>}
    </div>
  );
};

export function Details(props: Props) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState('PICKED' as Status);
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState<boolean>(false);
  const [openPackConfirmUpdateState, setPackOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openPackages, setOpenPackages] = useState(false as boolean);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [boxCount, setBoxCount] = useState('');
  const [height, setHeight] = useState('');
  const [count, setCount] = useState('');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [dimensions, setDimensions] = useState<any>([]);
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [logs, setLogs] = useState([]);
  const [values, setValues] = useState(0);
  const [serialValue, setSerialValue] = useState<string>('')
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [inventoryItem, setInventoryItem] = useState({} as any);
  const [openDeleteInventoryItem, setOpenDeleteInventoryItem] = useState(
    false as boolean
  )
  const [id, setId] = useState(-1 as number);
  const [orderItem, setOrderItem] = useState({});
  const [units, setUnits] = useState([]);
  const [openUnitItems, setOpenUnitItems] = useState(false as boolean);
  const [skuUnits, setSkuUnits] = useState({});
  const [damaigItemDiolog, openDamaigItemDiolog] = useState(false)
  const handleBrokenItemAction = async () => {
    try {
      await operatorAssigmentItemIssue(order.id)
      handleNotfication('سفارش از لیست شما حذف شد', 'success')
      openDamaigItemDiolog(false)
      setTimeout(() => {

        history.goBack()
      }, 100);

    } catch (error) {
      handleNotfication('سفارشی یافت نشد', 'error')
    }
  }
  const classes = useStyles();
  const addDimensions = () => {
    const newDimension = {
      count,
      length,
      width,
      height,
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setLength('');
    setHeight('');
    setWidth('');
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const setUpdateStatus = () => {
    setPackOpenConfirmUpdateState(true);
  };
  const handlePackClose = () => {
    setPackOpenConfirmUpdateState(false);
    handleCloseDimensions();
  };
  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount('');
    setOpenListDimensions(false);
    // setDimensions([]);
  };
  const addOrderDimensions = async (action: any) => {
    try {
      const payload = { ...action };
      setLoading(true);
      const callback = await ordersRepository.addOrderDimensions({
        payload,
      });
      callback && callback();
      handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
    } catch (error) {
      handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
    } finally {
      setLoading(false);
    }
  };
  const addOrderDimension = () => {
    const { id } = props.match.params;
    addOrderDimensions({
      id: order.id,
      body: dimensions,
      callback: () => getOrderWithId(id),
    });
    handlePackClose();
    getOrderWithId(id);
  };
  const checkButtonDisabled = () => {
    const fields = [count, length, width, height];
    return fields.some(field => !field) && totalBoxCount < Number(boxCount);
  };

  const getOrderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
      getSkusUnit(response.data.items.map(el => el.variantId))
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const logsGet = async (id: any) => {
    const payload = { id };
    try {
      const response = await ordersRepository.getLogs({ payload });
      setLogs(response.data);
    } catch (error) {
      handleError(error)
    }
  };

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);

  useEffect(() => {
    const { id } = props.match.params;
    logsGet(id);
    getOrderWithId(id);
  }, []);

  useEffect(() => {
    return () => {
      clearOrder();
    };
  }, []);

  const clearOrder = async () => {
    setOrder({});
  };


  const changeStatusOrder = () => {
    const { id } = props.match.params;
    updateOrderStatus({
      id: order.id,
      body: {
        status: previewState.replace(/"/g, ''),
      },
      pagination: {},
      callback: () => {
        props.history.push('/warehouse-operator-orders-mob');
        getOrderWithId(id)
        handleClose();
      }
    });
  };

  const updateOrderStatus = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const { pagination, callback } = await ordersRepository.updateOrderStatus({
        payload,
      });
      callback && callback();
      handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
    } catch (error) {
      handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
    } finally {
      setLoading(false);
    }
  };

  const warehouseZoneUnit = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { response, count } =
        await warehouseUnitRepository.getWarehouseZoneUnit({ payload });
      setUnits(response.data);
      setCount(count.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };
  const handleCloseDamage = () => {
    setAnchorEl(null);
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValues(newValue);
  };

  const onSubmit = (e: any) => {
    e.preventDefault()
    setLoading(true);
    const { id } = props.match.params;
    updateInventoryItemOrderItem(id, serialValue);
    setSerialValue('');
  };

  const updateInventoryItemOrderItem = async (
    orderId: number,
    serial: string
  ) => {
    const payload = { id: serial, body: orderId };
    try {
      await orderItemsRepository.updateInventoryItemOrderItem({
        payload,
      });
      getOrderWithId(orderId);
      handleNotfication('آیتم برداشته شد', 'success');
    } catch (error) {
      setErrorModal(true);
      setLoading(false)
    }
  };

  const locateItem = (inventoryItem: any) => {
    setInventoryItem(inventoryItem);
    setOpenDeleteInventoryItem(true);
  };

  const getWarehouseZoneUnitAction = (id: number) => {
    warehouseZoneUnit({
      skuId: { equals: id },
      page: 0,
      size: 500,
    });
  };

  const handleChangeStatus = (orderItem) => {
    setId(orderItem.variantId);
    setOrderItem(orderItem);
    getWarehouseZoneUnitAction(orderItem.variantId);
  };
  const handleCloseDialog = () => {
    setOpenDeleteInventoryItem(false);
  };
  const deleteInventoryItemFromOrderItems = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const callback =
        await inventoryItemsRepository.deleteInventoryItemFromOrderItem({
          payload,
        });
      handleNotfication('تغییر وضعیت آیتم انبار با موفقیت انجام شد', 'success');
      callback && callback();
    } catch (error) {
      handleNotfication('تغییر وضعیت آیتم انبار انجام نشد', 'error');
    } finally {
      setLoading(false);
    }
  };
  const deleteInventoryItemFromOrderItem = () => {
    const { id } = props.match.params;
    deleteInventoryItemFromOrderItems({
      id: inventoryItem.id,
      pagination: {},
      callback: () => {
        handleCloseDialog();
        getOrderWithId(id);
        // props.history.push('/warehouse-operator-orders-mob');
      },
    });
  };
  const handleCloseUnitModal = () => {
    setOpenUnitItems(false);
  };
  const handleCloseErrorDialog = () => {
    setErrorModal(false);
  };
  const pickItem = (unit: warehouseZoneUnits) => {
    getInventoryItemsAction(id, unit.id);
  };

  const getSkusUnit = async (data: any) => {
    try {
      const response = await warehouseUnitRepository.getWarehouseZoneUnitBySkuId({
        payload: {
          page: 0,
          size: 500,
          "skuId.in": data
        }
      })
      setSkuUnits(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const handleBrokenItem = () => {
    openDamaigItemDiolog(true)
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={damaigItemDiolog}
        fullWidth
        onClose={() => openDamaigItemDiolog(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>


          <Typography>
            سفارش دارای مشکل است و نمیتوانید آن را تکمیل کنید؟
          </Typography>
          <Box marginTop="16px" display="flex">
            <Button style={{ marginLeft: "10px" }} onClick={() => openDamaigItemDiolog(false)} variant='outlined' >خیر</Button>
            <Button onClick={handleBrokenItemAction} variant='contained'>بله</Button>
          </Box>
          <div>

          </div>
        </DialogContent>

      </Dialog >
      <Grid container>
        <Paper
          className={classes.tileBar}
        >
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} className={classes.icon} />

          </Button>
          <Grid container xs={12} style={{ justifyContent: 'center', alignItems: 'center' }}>
            {
              order?.id && <>
                <div
                  aria-label="more"
                  id="long-button"
                  aria-controls={openMenu ? 'long-menu' : undefined}
                  aria-expanded={openMenu ? 'true' : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                >

                  <RonadIcons name='chevron-down' />

                </div>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    'aria-labelledby': 'long-button',
                  }}
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleCloseDamage}
                  PaperProps={{
                    style: {
                      maxHeight: 48 * 4.5,

                    },
                  }}
                >
                  <MenuItem onClick={handleCloseDamage}>
                    <div onClick={handleBrokenItem}>سفارش دارای مشکل است</div>
                  </MenuItem>
                </Menu>
              </>
            }

            <p >
              {`
         سفارش
     
        `}
            </p>
            <Typography variant="h6" component="h6">
              <span style={{ marginRight: '8px' }} >{order.id}</span>
            </Typography>


          </Grid>
          <span >
            <Link to={'/mobile-home'} style={{ justifySelf: 'right' }}>
              <Icon path={mdiHomeOutline} size={1.2} color={'black'} />
            </Link>
          </span>
        </Paper>
      </Grid>

      <Box className={classes.tabs}>
        <Tabs
          values={values}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label=" برداشتن کالا" {...a11yProps(0)} />
          <Tab label=" جزییات" {...a11yProps(1)} />
          <Tab label="تاریخچه" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <Grid container direction="row" justify="space-between" xs={12} style={{ marginBottom: '32px', marginTop: '55px' }}>
        <TabPanel values={values} index={0}>
          <form onSubmit={onSubmit}>
            <Grid container item spacing={1} className={classes.detail} alignItems="center">
              <Grid container item xs={12} alignItems="center" >
                <div style={{ display: 'flex', width: '100%' }}>
                  <TextField
                    variant='outlined'
                    fullWidth
                    id="serial"
                    name="serial"
                    value={serialValue}
                    onChange={(e) => setSerialValue(e.target.value)}
                    autoFocus
                    label="سریال کالا"
                    InputProps={{
                      startAdornment: <Icon path={mdiBarcodeScan} size={1} color="black" />
                    }}
                  />
                </div>
              </Grid>
              <Grid container item xs={12} >
                {loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  order?.items && (
                    <ListOrderItems
                      data={order.items}
                      units={skuUnits}
                      setOpenUnits={handleChangeStatus}
                      locateItem={id => locateItem(id)}
                    />
                  )
                )}
              </Grid>
            </Grid>
            <Grid
              container
              lg={12}
              md={12}
              xs={12}
              className={classes.btnBottom}
            >
              <Grid
                container
                style={{
                  justifyContent: 'center',
                }}
              >
                <Button
                  fullWidth
                  aria-label="register-parcel"
                  onClick={changeStatusOrder}
                  color="primary"
                  variant="contained"
                  disabled={
                    order?.items?.filter(item => item.status !== 'PICKED').length !== 0
                  }
                >
                  <span style={{ paddingRight: '5px' }}>{'تایید جمع آوری سفارش'}</span>
                </Button>
              </Grid>
            </Grid>
          </form>
        </TabPanel>
        <TabPanel values={values} index={1}>
          <Grid xs={12}>
            <Card >
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل :  '}</span>
                  <span style={{ flex: 1 }}>
                    <Can
                      role={authContext.user.role}
                      perform="orders:changeOrderStatus"
                      yes={() => (
                        <FormControl style={{ width: '100%' }}>
                          <Icon
                            path={mdiPencilOutline}
                            size={1}
                            className={classes.changStatusIcon}
                          />
                          <Select
                            className={classes.changStatusBox}
                            fullWidth
                            inputProps={{
                              name: 'name',
                              id: 'uncontrolled-native',
                            }}
                            name={'status'}
                            id={order.rubikaId}
                            value={[{}]}
                            IconComponent={() => null}
                            renderValue={() => (
                              <span className={classes.renderValue}>
                                {translate(order.status, 'order')}
                              </span>
                            )}
                          >
                            <RadioGroup
                              className={classes.radioGroup}
                              aria-label={'status'}
                              name={'status$'}
                              value={'item'}
                              onChange={(
                                e: React.ChangeEvent<{
                                  value: unknown;
                                }>
                              ) =>
                                handleOpenConfirmUpdateState(
                                  `"${e.target.value}"` as Status
                                )
                              }
                            >
                              {rulesOrderStatus[order.status]?.map(
                                (item: any, index: number) => (
                                  <FormControlLabel
                                    className={classes.radioGroupItem}
                                    key={index}
                                    checked={order.status === item}
                                    value={item}
                                    disabled={
                                      rulesAdminChangeOrderStatus[
                                        authContext.user.role
                                      ].indexOf(item) === -1
                                    }
                                    control={<Radio />}
                                    label={translate(item, 'order')}
                                  />
                                )
                              )}
                            </RadioGroup>
                          </Select>
                        </FormControl>
                      )}
                      no={() => <span>{translate(order.status, 'order')}</span>}
                    />
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع ارسال:  '}</span>
                  <span style={{ flex: 1 }}>
                    {translate(order?.deliveryType)}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'شیوه پرداخت:'}
                  </span>
                  <span dir="ltr">{order?.paymentType}</span>
                </div>
                {order?.paymentType === 'COD' && (
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon path={mdiCurrencyUsd} size={1} className={classes.icon} />
                      {'مبلغ فاکتور:  '}
                    </span>
                    <span dir="ltr">{order?.codValue}</span>
                  </div>
                )}

                <div className={classes.item}>
                  <span className={classes.label}>{'کدپیگیری:  '}</span>
                  <span style={{ flex: '1' }}>{order?.trackingCode}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'تعداد بسته:  '}</span>
                  <span style={{ flex: '1' }}>
                    {order?.orderPackages && order?.orderPackages.length}
                  </span>
                </div>
                <Divider style={{ width: '100%' }} />
              </CardContent>
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{' تاریخ ثبت:  '}</span>
                  <span style={{ flex: '1' }}>
                    {order.registrationDate &&
                      `${jMoment(order.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'تاریخ تحویل:  '}</span>
                  <span style={{ flex: '1' }}>
                    {order.deliveryDate &&
                      `${jMoment(order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{' بازه تحویل:  '}</span>
                  <span style={{ flex: '1' }}>
                    {order.deliveryStartTime &&
                      jMoment(order.deliveryStartTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                    {' - '}
                    {order.deliveryEndTime &&
                      jMoment(order.deliveryEndTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'استان:  '}</span>
                  <span style={{ flex: '1' }}>{order?.customerProvince}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'شهر:  '}</span>
                  <span style={{ flex: '1' }}>{order?.customerCity}</span>
                </div>
                <Divider style={{ width: '100%' }} />
              </CardContent>
              <CardContent>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام:  '}</span>

                  <span style={{ flex: '1' }}>{order.customerName}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{' کد ملی:  '}</span>
                  <span style={{ flex: '1' }}>{order?.customerNationalCode}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره همراه:  '}</span>
                  <span style={{ flex: '1' }}>
                    {formaterPhoneNumber(order.customerMobileNumber)}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{' شماره ثابت:  '}</span>
                  <span style={{ flex: '1', textAlign: 'right' }} dir="ltr">
                    {order?.customerPhoneNumber}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label} style={{ alignSelf: 'start' }}>
                    {'آدرس:  '}
                  </span>
                  <span style={{ flex: '1' }}>
                    {order.customerAddress && order.customerAddress}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{' کد پستی:  '}</span>
                  <span style={{ flex: '1' }}>{order?.customerZipCode}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'توضیحات:  '}</span>
                  <span style={{ flex: '1' }}>
                    {order.description && order.description}
                  </span>
                </div>
              </CardContent>
            </Card>
            {order?.deliveryType !== 'COURIER' && (
              <Card style={{ marginTop: '16px' }}>
                <CardContent>
                  {order?.postOrders?.length &&
                    order?.postOrders.map((order, index) => {
                      return (
                        <>
                          <Typography
                            color="secondary"
                            component="h3"
                            variant="h6"
                          >
                            بسته پستی {index + 1}
                          </Typography>
                          <div
                            className={classes.item}
                            style={{ marginTop: '16px' }}
                          >
                            <span className={classes.label}>{'وضعیت:  '}</span>
                            <span style={{ flex: '1' }}>
                              {translate(order.postOrderStatus, 'order')}
                            </span>
                          </div>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'کد رهگیری:  '}
                            </span>
                            <span style={{ flex: '1' }}>{order.barcode}</span>
                          </div>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'وزن (گرم):  '}
                            </span>
                            <span style={{ flex: '1' }}>{order.weight}</span>
                          </div>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'هزینه (ریال):  '}
                            </span>
                            <span style={{ flex: '1' }}>{order.totalPrice}</span>
                          </div>
                        </>
                      );
                    })}
                </CardContent>
              </Card>
            )}
          </Grid>
        </TabPanel>
        <TabPanel values={values} index={2}>
          <Card >
            <Grid item xs={12}>
              <Timeline align="left" >
                {logs
                  ?.slice()
                  .reverse()
                  .map((log, index: number) => (
                    <TimelineItem
                      className={classes.missingOppositeContent}
                      key={index}
                    >
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            backgroundColor: colorStatus[log.newStatus],
                            border: index === 0 ? 'solid 4px #DF9234' : '',
                          }}
                        >
                          <Icon path={iconStatus[log.newStatus]} size={1} />
                        </TimelineDot>
                        {index !== logs?.length - 1 ? (
                          <TimelineConnector />
                        ) : (
                          ''
                        )}
                      </TimelineSeparator>
                      <TimelineContent className={classes.paperHistory}>
                        <div style={{ padding: '10px' }}>
                          <div className={classes.contentBox}>
                            <div >

                              <span data-cy="status">
                                {translate(log.newStatus, 'order')}
                              </span>
                            </div>
                            <div
                              style={{
                                flex: 2,
                                textAlign: 'right',
                                justifyContent: 'center',
                              }}
                            >

                              <Can
                                role={authContext.user.role}
                                perform="user-name:dontShowInLogs"
                                no={() => (
                                  <>
                                    <span>{log.modifierName}</span>
                                    <span>  -  </span>
                                  </>
                                )}
                              />
                              <span data-cy="role">
                                {translate(log.modifierRole, 'user')}
                              </span>
                            </div>
                            <Typography component="div" style={{ flex: 1 }}>
                              {log.time &&
                                jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                  .locale('fa')
                                  .format('jYYYY/jMM/jDD - HH:mm')}
                            </Typography>
                          </div>
                        </div>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
              </Timeline>
            </Grid>
          </Card>
        </TabPanel>
      </Grid>

      <Modal
        maxWidth="xl"
        onClose={() => setOpenPackages(false)}
        open={openPackages}
        title={
          <div style={{ textAlign: 'center' }}>

          </div>
        }
        content={<PackageList data={order?.postOrders} />}
      />

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(order.status, 'order')}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'order')}"


        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>

              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="medium"
                color="primary"

              >
                {'بله'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'خیر'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openPackConfirmUpdateState}
        onClose={handlePackClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handlePackClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handlePackClose}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`از تغییر وضعیت سفارش
        به
       " ${translate('PACKAGED' as Status, 'order')}"
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1} >
            <Grid item xs={6}>

              <Button
                fullWidth
                autoFocus
                onClick={addOrderDimension}
                variant="contained"
                color="primary"
                size="medium"
              >
                {'تغییر وضعیت سفارش'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handlePackClose()}
                size="medium"
                color='primary'
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          {boxCount && openListDimensions ? (
            <Grid container alignItems="center" spacing={4}>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiCounter} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="count"
                    name="count"
                    value={count}
                    onChange={e => setCount(e.target.value)}
                    label="تعداد"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableRowHeight} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="length"
                    name="length"
                    value={length}
                    onChange={e => setLength(e.target.value)}
                    label="طول"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableColumnWidth} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="width"
                    name="width"
                    value={width}
                    onChange={e => setWidth(e.target.value)}
                    label="عرض"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiRuler} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="height"
                    name="height"
                    value={height}
                    onChange={e => setHeight(e.target.value)}
                    label="ارتفاع"
                  />
                </Grid>
              </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item xs={12}>
                <p>{'تعداد بسته بندی های سفارش را وارد کنید'}</p>
              </Grid>
              <Grid item xs={1}>
                <Icon path={mdiCounter} size={1} />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  fullWidth
                  id="boxCount"
                  name="boxCount"
                  value={boxCount}
                  onChange={e => setBoxCount(e.target.value)}
                  label="تعداد بسته"
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          {boxCount && openListDimensions ? (
            <Grid container spacing={1} >
              <Grid item xs={6}>

                <Button
                  fullWidth
                  autoFocus
                  onClick={
                    totalBoxCount < Number(boxCount)
                      ? addDimensions
                      : setUpdateStatus
                  }
                  variant="contained"
                  color="primary"
                  disabled={checkButtonDisabled()}
                  size="medium"
                >
                  {totalBoxCount >= Number(boxCount)
                    ? 'مرحله بعد'
                    : 'اضافه کردن بسته'}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => handlePackClose()}
                  size="medium"
                  color='primary'
                >
                  {'بازگشت'}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item xs={6}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setOpenListDimensions(true)}
                  variant="contained"
                  color="primary"
                  disabled={!boxCount}
                  size="medium"
                >
                  {'مرحله بعد'}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => handleCloseDimensions()}
                  size="medium"
                >
                  {'انصراف'}
                </Button>

              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>



      <Dialog
        fullWidth
        open={openDeleteInventoryItem}
        onClose={handleCloseDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDialog ? (
              <IconButton aria-label="close" onClick={handleCloseDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {` از 
            جایگذاری آیتم انبار با سریال
          "${inventoryItem.serialNumber}"
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                onClick={deleteInventoryItemFromOrderItem}
                fullWidth
                variant="contained"
                size="medium"
                color="primary"

              >
                {'تایید جایگذاری'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialog}
                variant="outlined"
                size="medium"
                color="primary"

              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={errorModal}
        onClose={handleCloseErrorDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseErrorDialog ? (
              <IconButton aria-label="close" onClick={handleCloseErrorDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {'سریال آیتم اشتباه'}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                onClick={handleCloseErrorDialog}
                variant="contained"
                color="primary"
                size="medium"
              >
                {'متوجه شدم'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        onClose={handleCloseUnitModal}
        maxWidth="lg"
        open={openUnitItems}
        title={
          <div className={classes.addIcon}>
            <Icon path={mdiSelectionMarker} size={4} color="#5c5c5c" />
          </div>
        }
        content={
          <OrderItemDetail
            units={units.filter(el => el.stock > 0)}
            onClose={handleCloseUnitModal}
            orderItem={orderItem}
            pickItem={unit => pickItem(unit)}
          />
        }
      />
    </div >
  );
}


export default Details;
